export default {
    fr:{
        'Déduire':'Déduire',
        'Montant total/expert':'Montant total/expert',
        'Montant total/client':'Montant total/client',
        // 'Ajouter des détails':'Ajouter des détails',

        'Faire une régularisation-Prestation complémentaire':'Faire une régularisation-Prestation complémentaire',
        'Total des astreintes':'Total des astreintes',
        'Total des HNO':'Total des HNO',
        'Total des notes de frais':'Total des notes de frais',
        'Notes de frais':'Notes de frais',
        'Montant total de la régularisation':'Montant total de la régularisation',
        //Demandes à valider_57
        'Demandes à valider':'Demandes à valider',
        'Documents à valider':'Documents à valider',
        'Demandes d\'interruption':'Demandes d\'interruption',
        'Kbis':'Kbis',
        'Assurance':'Assurance',
        'Attestation d\'assurance':'Attestation d\'assurance',
        'Attestation URSSAF':'Attestation URSSAF',
        // 'Attestation sur l\'honneur':'Attestation sur l\'honneur',

        'Type de document':'Type de document',
        'N° du doc.':'N° du doc.',
        'Date de téléchargement':'Date de téléchargement',
        'Date du document':'Date du document',
        // 'Date d\'émission':'Date d\'émission',

        // 'Date de validité':'Date de validité',
        // 'Non validé':'Non validé',
        'Rejeté':'Rejeté',
        'Préciser le motif du rejet':'Préciser le motif du rejet',
        'Demandeur':'Demandeur',
        'Type Demandeur':'Type Demandeur',
        'Demande d\'interruption de mission':'Demande d\'interruption de mission',
        'Date Effective de l\'interruption':'Date Effective de l\'interruption',
        'Date Effective(souhaitée)':'Date Effective(souhaitée)',
        'Date de demande':'Date de demande',
        'Motif de l\'interruption':'Motif de l\'interruption',
        'Traitées':'Traitées',

        'Valider la demande d\'interruption de mission':'Valider la demande d\'interruption de mission',
        'Date effective de l\'interruption':'Date effective de l\'interruption',
        'Motif à diffuser':'Motif à diffuser',
        'Rejeter la demande d\'interruption de mission':'Rejeter la demande d\'interruption de mission',
        // 'Motif du rejet':'Motif du rejet',

        //suppression de compte

        'Demandes de suppression':'Demandes de suppression',
        'Demandes de suppression à valider':'Demandes de suppression à valider',
        'Date de suppression':'Date de suppression',
        'Statut de la demande':'Statut de la demande',
        'Motif de la suppression':'Motif de la suppression',

        //Autres
        //Loggin
        'Cette adresse mail n\'appartient à aucun utilisateur':'Cette adresse mail n\'appartient à aucun utilisateur',
        'Le mot de passe saisi est incorrect':'Le mot de passe saisi est incorrect' ,
        //PC/client
        'Aucune donnée prestation complémentaire n\'est définie':'Aucune donnée prestation complémentaire n\'est définie',
        'Aucune donnée astreinte n\'est définie':'Aucune donnée astreinte n\'est définie',
        'Aucune donnée HNO n\'est définie':'Aucune donnée HNO n\'est définie',
        //Logging client/existing company
        'Une invitation vient d\'être envoyée à votre entreprise':'Une invitation vient d\'être envoyée à votre entreprise',
        'Une invitation a été déjà envoyée!':'Une invitation a été déjà envoyée!',
        'Une invitation a été déjà envoyée à l\'admin de votre entreprise “xxxx” sur  la plateforme. Vous recevrez une notification après son acceptation':'Une invitation a été déjà envoyée à l\'admin de votre entreprise “xxxx” sur  la plateforme. Vous recevrez une notification après son acceptation',
        //Création AO/sauvegarde du draft
        'Votre AO a été sauvegardé avec succès  dans DRAFT':'Votre AO a été sauvegardé avec succès  dans DRAFT',
        'Liste des drafts  des appels d\'offres':'Liste des drafts  des appels d\'offres',
        'Progrès':'Progrès',
        'Toutes les sous catégories':'Toutes les sous catégories',
        //Répondre à un AO/un compte non complété
        'Nous vous invitons à compléter votre profil en cliquant ici, pour pouvoir postuler aux appels d\'offres':'Nous vous invitons à compléter votre profil en cliquant ici, pour pouvoir postuler aux appels d\'offres',
        //Données CV\Compléter profil
        'Détails du diplôme':'Détails du diplôme',
        'Université/Ecole':'Université/Ecole',
        'Secteur d\'activité de l\'entreprise (facultatif)':'Secteur d\'activité de l\'entreprise (facultatif)',
        'La date de fin doit être postérieure à la date de début':'La date de fin doit être postérieure à la date de début',
        'Votre profil a été complété avec succès!':'Votre profil a été complété avec succès!',
        'Félicitation!':'Félicitation!',
        'page d\'accueil':'page d\'accueil',
        //Répondre à un AO
        'Aujourd\'hui':'Aujourd\'hui',
        'Votre candidature a été envoyée avec succès!':'Votre candidature a été envoyée avec succès!',
        //Création compte expert externe
        'Ce profil a été créé avec succès sous la référence':'Ce profil a été créé avec succès sous la référence',
        'Inviter un expert (externe)':'Inviter un expert (externe)',
        'Renvoyer une invitation':'Renvoyer une invitation',
        'Invitation acceptée':'Invitation acceptée',
        'Envoyer une invitation':'Envoyer une invitation',
        'Aucun commentaire sur ce CV':'Aucun commentaire sur ce CV',
        'Toutes les catégories':'Toutes les catégories',

        //Planification RDV
        'Votre rendez-vous a été planifié avec succès!':'Votre rendez-vous a été planifié avec succès!',
        'Planifié':'Planifié',
        'Replanifié':'Replanifié',
        'Annulé':'Annulé',
        'Visioconférence':'Visioconférence',
        'Audioconférence':'Audioconférence',
        'Sur site':'Sur site',

        //Répondre à un AO
        'Vous avez déjà répondu à cette offre':'Vous avez déjà répondu à cette offre',
        'AO clôturé le':'AO clôturé le',
        //Document administratifs
        'Téléchargez votre pièce d\'identité scannée recto-verso':'Téléchargez votre pièce d\'identité scannée recto-verso',
        'Date d\'expiration':'Date d\'expiration',

        //Activation compte client
        'Vous allez recevoir un e-mail qui va vous informer de l\'activation de votre compte par notre équipe dans les prochaines heures.':'Vous allez recevoir un e-mail qui va vous informer de l\'activation de votre compte par notre équipe dans les prochaines heures.',
        'Votre demande pour rejoindre':'Votre demande pour rejoindre',
        'est en cours de traitement et en attente d\'acceptation. Vous recevrez une notification par e-mail dès qu\'elle sera validée.':'est en cours de traitement et en attente d\'acceptation. Vous recevrez une notification par e-mail dès qu\'elle sera validée.',
        'Invitation est en attente!':'Invitation est en attente!',
        'L\'activation du compte est en cours...':'L\'activation du compte est en cours...',
        'Finalisez votre profil!':'Finalisez votre profil!',
        'Finalisez votre profil en cliquant ici':'Finalisez votre profil en cliquant ici',

        'L\'activation du compte est en cours…':'L\'activation du compte est en cours…',
        'Votre demande de rejoindre “Nom du client” est en attente d\'acceptation. Vous serez notifié par mail après sa validation.':'Votre demande de rejoindre “Nom du client” est en attente d\'acceptation. Vous serez notifié par mail après sa validation.',

        //AO
        'Nb. de jours BDC (estimé)':'Nb. de jours BDC (estimé)',
        'Fréq. de renouv. BDC':'Fréq. de renouv. BDC',
        'Etes-vous sûr de vouloir clôturer la publication?':'Etes-vous sûr de vouloir clôturer la publication?',
        //CRA
        'En attente validation-Expert':'En attente validation-Expert',
        'En attente validation-Client':'En attente validation-Client',
        // 'Non validé':'Non validé',
        // 'Validé':'Validé',
        //Loggin
        'Cette adresse email est déjà utilisée par un compte utilisateur.':'Cette adresse email est déjà utilisée par un compte utilisateur.',
        //a la modification d\'un statut de candidature
        'Le statut de candidature a été modifié':'Le statut de candidature a été modifié',
        //validation proposition commerciale
        'Proposition commerciale validée. La génération du BDC se fera automatiquement à la validation de l\'ordre de mission par l\'expert.':'Proposition commerciale validée. La génération du BDC se fera automatiquement à la validation de l\'ordre de mission par l\'expert.',
        //validation ordre de mission
        'Ordre de mission validé. La génération du BDC se fera automatiquement à la validation de la proposition commerciale par le client.':'Ordre de mission validé. La génération du BDC se fera automatiquement à la validation de la proposition commerciale par le client.',
        //Autres
        'Informations sauvegardées':'Informations sauvegardées',
        'Champ requis':'Champ requis',
        'Données profil sauvegardées':'Données profil sauvegardées',
        'Données CV sauvegardées':'Données CV sauvegardées',
        'Données préférences sauvegardées':'Données préférences sauvegardées',
        'CV lié(s) à l\'AO':'CV lié(s) à l\'AO',
        'Une candidature existe déjà avec le même CV pour cet AO':'Une candidature existe déjà avec le même CV pour cet AO',
        'Avez-vous des modifications à faire sur le CRA de la prestation complémentaire?':'Avez-vous des modifications à faire sur le CRA de la prestation complémentaire?',
        'Délai de paiement est à la date de facture':'Délai de paiement est à la date de facture',
        'Dispo. à vérifier':'Dispo. à vérifier',
        'Une régularisation liée à la même référence du CRA existe déjà!':'Une régularisation liée à la même référence du CRA existe déjà!',
        'L\'utilisateur xxxxx existe déjà dans la liste de vos collaborateurs!':'L\'utilisateur xxxxx existe déjà dans la liste de vos collaborateurs!',//#
        'L\'adresse mail xxxxx appartient déjà à un utilisateur de la plateforme.':'L\'adresse mail xxxxx appartient déjà à un utilisateur de la plateforme.',//#
        'Cette adresse email est déjà utilisée par un autre compte utilisateur':'Cette adresse email est déjà utilisée par un autre compte utilisateur',
        'Invitation envoyée!':'Invitation envoyée!',
        'Invitation renvoyée':'Invitation renvoyée',
        'Valorisez votre profil auprès des clients et augmentez la visibilité de votre CV!':'Valorisez votre profil auprès des clients et augmentez la visibilité de votre CV!',
        'Données personnelles mises à jour':'Données personnelles mises à jour',
        'Données CV mises à jour':'Données CV mises à jour',
        'Données préférences mises à jour':'Données préférences mises à jour',
        'Données société mises à jour':'Données société mises à jour',
        'Souhaitez-vous sauvegarder ces informations?':'Souhaitez-vous sauvegarder ces informations?',
        'L\'équipe est requise pour créer une mission':'L\'équipe est requise pour créer une mission',
        'Vous avez déjà postulé à cet appel d\'offres':'Vous avez déjà postulé à cet appel d\'offres',
        'La date du RDV ne peut pas être antérieure à la date d\'aujourd\'hui':'La date du RDV ne peut pas être antérieure à la date d\'aujourd\'hui',
        'Réf.mission(si lié à une mission)':'Réf.mission(si lié à une mission)',
        'Nb d\'astreintes':'Nb d\'astreintes',
        'Nb d\'heures':'Nb d\'heures',
        'Prestation complémentaire mise à jour':'Prestation complémentaire mise à jour',
        'CRA PC mise à jour':'CRA PC mise à jour',
        'Les mots de passe saisis ne sont pas identiques':'Les mots de passe saisis ne sont pas identiques',

        'La régularisation de la PC a été créée avec succès':'La régularisation de la PC a été créée avec succès',
        'La régularisation de la prestation complémentaire a été mise à jour':'La régularisation de la prestation complémentaire a été mise à jour',
        'Demande d\'interruption envoyée':'Demande d\'interruption envoyée',
        'Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?':'Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?',
        // 'Oui':'Oui',
        // 'Non':'Non',
        'Vous avez déjà envoyé une demande':'Vous avez déjà envoyé une demande',
        'Validée':'Validée',
        'Rejetée':'Rejetée',
        'Valider la demande d\'annulation de mission':'Valider la demande d\'annulation de mission',
        'Motif d\'annulation':'Motif d\'annulation',
        'Invitation envoyée avec succès!':'Invitation envoyée avec succès!',
        'L\'expert a été créé avec succès!':'L\'expert a été créé avec succès!',
        'Entreprise pas encore validée par High Tech Hires':'Entreprise pas encore validée par High Tech Hires',
        'Entreprise validée par High Tech Hires le ':'Entreprise validée par High Tech Hires le ',//#
        'Nb de jours BDC':'Nb de jours BDC',
        'Heure début':'Heure début',
        'Heure fin':'Heure fin',
        // 'Nb d\'heures':'Nb d\'heures',
        'Le document doit être de format pdf':'Le document doit être de format pdf',
        'Votre compte n\'est pas encore validé':'Votre compte n\'est pas encore validé',
        'Ajouter une astreinte':'Ajouter une astreinte',
        'Ajouter un HNO':'Ajouter un HNO',
        'Date d\'obtention':'Date d\'obtention',

        //modifications
        'Mon Compte':'Mon Compte',
        'la déchéance du terme de l\'ensemble des sommes dues par le Client et leur exigibilité immédiate ; et': 'la déchéance du terme de l\'ensemble des sommes dues par le Client et leur exigibilité immédiate ; et',
        'la suspension immédiate des Services en cours jusqu\'au complet paiement de l\'intégralité des sommes dues par le Client ; et': 'la suspension immédiate des Services en cours jusqu\'au complet paiement de l\'intégralité des sommes dues par le Client ; et',
        'La facture est générée par le système une fois le compte rendu d\'activité(CRA) est validé par le consultant et le client.':'La facture est générée par le système une fois le compte rendu d\'activité(CRA) est validé par le consultant et le client.',
        'au titre de l\'article L. 441-10 du Code de commerce, toute somme non payée dans les délais prévus sera productive d\'intérêts au taux appliqué par la Banque centrale européenne à son opération de refinancement la plus récente majoré de dix (10) points de pourcentage et ouvrira droit au paiement d\'une somme forfaitaire de 40 euros au titre de l\'indemnité pour frais de recouvrement ;': 'au titre de l\'article L. 441-10 du Code de commerce, toute somme non payée dans les délais prévus sera productive d\'intérêts au taux appliqué par la Banque centrale européenne à son opération de refinancement la plus récente majoré de dix (10) points de pourcentage et ouvrira droit au paiement d\'une somme forfaitaire de 40 euros au titre de l\'indemnité pour frais de recouvrement ;',
        'les pénalités de retard sont exigibles dès le premier jour de retard sans qu\'une mise en demeure soit nécessaire et courent jusqu\'au paiement intégral de la totalité des sommes dues, intérêts compris.':'les pénalités de retard sont exigibles dès le premier jour de retard sans qu\'une mise en demeure soit nécessaire et courent jusqu\'au paiement intégral de la totalité des sommes dues, intérêts compris.',
        '5.2. Dans le cas du service « VMS »': '5.2. Dans le cas du service « VMS »',
        '5.2.2. L\'ESN est informé et accepte expressément que tout retard de paiement de tout ou partie d\'une somme due à son échéance entraînera automatiquement et sans mise en demeure préalable :':'5.2.2. L\'ESN est informé et accepte expressément que tout retard de paiement de tout ou partie d\'une somme due à son échéance entraînera automatiquement et sans mise en demeure préalable :',
        '5.2.1. Dans le cas où la plateforme est utilisée comme outil par les ESN pour la gestion de leurs prestations. La validation par le Client et le Prestataire entraîne l\'édition d\'un Bon de commande, reprenant la description de la Mission créée par l\'ESN, son prix, les dates de début et de fin de Mission ainsi que les conditions de paiement.':'5.2.1. Dans le cas où la plateforme est utilisée comme outil par les ESN pour la gestion de leurs prestations. La validation par le Client et le Prestataire entraîne l\'édition d\'un Bon de commande, reprenant la description de la Mission créée par l\'ESN, son prix, les dates de début et de fin de Mission ainsi que les conditions de paiement.',

        'Les ESN sont informés que l\'utilisation de ce service est payante et que les prix s\'entendent en euros, nets et hors taxes.': 'Les ESN sont informés que l\'utilisation de ce service est payante et que les prix s\'entendent en euros, nets et hors taxes.',
        'Le taux des pénalités de retard est appliqué sur le montant TTC de la facture et non soumis à TVA.':'Le taux des pénalités de retard est appliqué sur le montant TTC de la facture et non soumis à TVA.',

        'Collaborateurs HTH':'Collaborateurs HTH',
        'Simulateur':'Simulateur',
        'Gestion des Clients':'Gestion des Clients',
        'Gestion des missions':'Gestion des missions',
        'Interruptions de mission':'interruptions de mission',
        'Missions clôturées':'Missions clôturées',
        'CRA à valider':'CRA à valider',
        'Facturation':'Facturation',
        'Besoins ouverts':'Besoins ouverts',
        'Candidats retenus':'Candidats retenus',
        'Missions en cours':'Missions en cours',
        'Factures clients non payées':'Factures clients non payées',
        'Factures experts non payées':'Factures experts non payées',
        'Chiffre d\'affaires':'Chiffre d\'affaires',
        'Total AO':'Total AO',
        'Analyse des missions':'Analyse des missions',
        'Statuts CRA':'Statuts CRA',
        'Rendez vous à venir':'Rendez vous à venir',
        'Nom*' :'Nom*',
        'Prénom*' : 'Prénom*',
        'Nouveaux inscrits à la platforme':'Nouveaux inscrits à la platforme',
        'Evolution chiffre d\'affaire':'Evolution chiffre d\'affaire',
        'Evolution de la marge brute et nette':'Evolution de la marge brute et nette',
        'Chiffre d\'affaire généré par CR':'Chiffre d\'affaire généré par CR',
        'Chiffre d\'affaires et marges':'Chiffre d\'affaires et marges',
        'Statut factures':'Statut factures',
        'Echéancier':'Echéancier',
        'Collaborateurs High Tech Hires':'Collaborateurs High Tech Hires',
        'Compte entreprise':'Compte entreprise',
        'Ajouter un expert':'Ajouter un expert',
        'Sous-catégorie':'Sous-catégorie',
        'Statut Doc.administratifs':'Statut Doc.administratifs',
        'Catégories':'Catégories',
        'Description (facultatif)':'Description (facultatif)',
        'Intitulé du poste*':'Intitulé du poste*',
        'Mon CV':'Mon CV',
        'Technique ?':'Technique ?',
        'Fonctionnelles ?':'Fonctionnelles ?',
        'Ajouter une qualification':'Ajouter une qualification',
        'Langue':'Langue',
        'Titre du poste recherché':'Titre du poste recherché',
        'Ajouter (3 nombre maximum d\'entrées)':'Ajouter (3 nombre maximum d\'entrées)',
        'Disponibilité *':'Disponibilité *',
        'Fréquenece (télétravail)':'Fréquenece (télétravail)',
        'Lieu de résidence *':'Lieu de résidence *',
        'Immediate':'Immediate',
        'Secteur d\'activité (facultatif)':'Secteur d\'activité (facultatif)',
        'Numéro TVA':'VAT Number',
        'Choisir votre pays':'Choisir votre pays',
        'Personnaliser plage de dates':'Personnaliser plage de dates',
        'Cette semaine':'Cette semaine',
        'Deux semaines':'Deux semaines',
        'Ce mois-ci':'Ce mois-ci',
        'Type du document':'Type du document',
        'Télécharger l\'attestation URSSAF':'Télécharger l\'attestation URSSAF',
        'Télécharger l\'attestation d\'assurance':'Télécharger l\'attestation d\'assurance',
        'Date de délivrence':'Date de délivrence',
        'Fiches des clients':'Fiches des clients',
        'Cvtheque': 'Cvtheque',
        'Tout': 'Tout',
        'AO': 'AO',
        'Type Facture':'Type Facture',
        'Annulée':'Annulée',
        'Validé ':'Validated',
        'Cra Nul':'Null CRA',
        'Interruption en cours':'Interruption en cours',
        'Tout les status':'Tout les status',

        'Nom client':'Nom client',
        'Nombre de missions':'Nombre de missions',
        'Pays et ville':'Pays et ville',
        'Chargé de recrutement affecté':'Chargé de recrutement affecté',
        'Statut doc administratifs':'Statut doc administratifs',
        'Nom d\'entrerprise * :':'Nom d\'entrerprise * :',
        'Adresse *':'Adresse *',
        'Code Postal *':'Code Postal *',
        'Numéro du TVA *':'Numéro du TVA *',
        'Siret *':'Siret *',
        'Informations de facturation':'Informations de facturation',
        'Adresse du siège':'Adresse du siège',
        'Collaborateurs d\'entreprise':'Collaborateurs d\'entreprise',
        'Autre adresse':'Autre adresse',
        'Numéro du TVA':'Numéro du TVA',
        'Coefficient/Montant':'Coefficient/Montant',
        'heures ouvrées':'heures ouvrées',
        'Ajouter une Astreinte':'Ajouter une Astreinte',
        'Documents commericiaux':'Documents commericiaux',
        'Liste des Collaborateurs':'Liste des Collaborateurs',
        'Nb. de candidatures':'Nb. de candidatures',
        'Candidatures "à interviewer"' : 'Candidatures "à interviewer"',
        'Candidatures "Retenues"' : 'Candidatures "Retenues"',
        'Date début Mission' : 'Date début Mission',
        'Date fin Mission' : 'Date fin Mission',
        'Durée Mission' : 'Durée Mission',
        'Budget Max/j' : 'Budget Max/j',
        'AO Créé par' : 'AO Créé par',
        'Resp. opérationnel' : 'Resp. opérationnel',
        'Resp. achat' : 'Resp. achat',
        'Nb. de recrutement':'Nb. de recrutement',
        'Code int. Client':'Code int. Client',
        'Statut Candidatures':'Statut Candidatures',
        'Ville/Pays':'Ville/Pays',
        'Début de publication':'Début de publication',
        'Fin de publication':'Fin de publication',
        'Modifier':'Modifier',
        'Min.années d\'exp.':'Min.années d\'exp.',
        'Techniques' : 'Techniques',
        'Fonctionnelles':'Fonctionnelles',
        'Aucune donnée':'Aucune donnée',
        'Langues':'Langues',
        'Données entreprises':'Données entreprises',
        'Masquer le nom de l\'entrerprise.':'Masquer le nom de l\'entrerprise.',
        'Cadres administratifs du projet':'Cadres administratifs du projet',
        'L\'équipe est requise pour créer une mission. L\'admin pourra affecter plus qu\'un rôle au même collaborateur.':'L\'équipe est requise pour créer une mission. L\'admin pourra affecter plus qu\'un rôle au même collaborateur.',
        'Modifier l\'appel d\'offres':'Modifier l\'appel d\'offres',
        'Données Projet':'Données Projet',
        'Exigences Projet':'Exigences Projet',
        'Catégories & Sous catégorie':'Catégories & Sous catégorie',
        'Durée de mission':'Durée de mission',
        'Budget de la mission':'Budget de la mission',
        'Budget maximum/jour':'Budget maximum/jour',
        'Visibilité Budget dans l\'AO':'Visibilité Budget dans l\'AO',
        'Description du poste':'Description du poste',
        'Présentation et motivation':'Présentation et motivation',
        'Télécharger':'Télécharger',
        'les scores de matching':'les scores de matching',
        'Dossiers clients':'Dossiers clients',
        'Clôturer le dossier':'Clôturer le dossier',
        'Créer mission':'Créer mission',
        'Voulez-vous empêcher la réinitialisation de la mission ?':'Voulez-vous empêcher la réinitialisation de la mission ?',
        'Ref.mission':'Ref.mission',
        'Créée le':'Créée le',
        'Réf. Besoin':'Réf. Besoin',
        'Nom Expert' :'Nom Expert',
        'Nom Client' :'Nom Client',
        'Réf. ordre de mission': 'Réf. ordre de mission',
        'Réf.BDC/Client': 'Réf.BDC/Client',
        'Réf.BDC/Expert': 'Réf.BDC/Expert',
        'Réf. proposition commerciale': 'Réf. proposition commerciale',
        'Réf.Commande Client': 'Réf.Commande Client',
        'Tj/Expert (TTC)': 'Tj/Expert (TTC)',
        'Commision appliquée': 'Commision appliquée',
        'Tj/Client (TTC)': 'Tj/Client (TTC)',
        'Marge nette': 'Marge nette',
        'Marge brute': 'Marge brute',
        'Motif d\'interruption ou d\'annulation': 'Motif d\'interruption ou d\'annulation',
        'Statut BDC':'Statut BDC',
        'Tj/Expert (HT)': 'Tj/Expert (HT)',
        'TVA Expert': 'TVA Expert',
        'Tj/Client (HT)': 'Tj/Client (HT)',
        'Renouvellement':'Renouvellement',
        'Réf. AO ou CVThèque': 'Réf. AO ou CVThèque',
        'Nombre de poste': 'Nombre de poste',
        'Réf. expert': 'Réf. expert',
        'Renouveler Mission':'Renouveler Mission',
        'Créer':'Créer',
        'Télécharger le BDC':'Télécharger le BDC',
        'Signée le': 'Signée le',
        'Rejetée le: ':'Rejetée le: ',
        'Ordre de mission N°:':'Ordre de mission N°:',
        'pas de description':'pas de description',
        'Signée Par: ':'Signée Par: ',
        'Rejetée Par: ':'Rejetée Par: ',
        'Réf:':'Réf:',
        'Réf':'Réf',
        'CRA':'CRA',
        'Réf.CRA':'Réf.CRA',
        'Date de validation/Expert':'Date de validation/Expert',
        'Date de validation/Client':'Date de validation/Client',
        'TJ HT/Expert':'TJ HT/Expert',
        'TJ HT/Client':'TJ HT/Client',
        'Proposition commerciale':'Proposition commerciale',
        'Compte rendu  d\'activité':'Compte rendu  d\'activité',
        'de ':'de ',
        'CRA & Factures':'CRA & Factures',
        'Réf.Int.Client': 'Réf.Int.Client',
        'Total HNO Client': 'Total HNO Client',
        'Total HNO Expert': 'Total HNO Expert',
        'Total astreintes Client': 'Total astreintes Client',
        'Total astreintes Expert': 'Total astreintes Expert',
        'Date de validation CRA': 'Date de validation CRA',
        'Délai Paiement': 'Délai Paiement',
        'Statut Paiement/Client': 'Statut Paiement/Client',
        'Statut Paiement/Expert': 'Payment Status/Expert',
        'TJ Expert': 'TJ Expert',
        'Date Paiement/Client':'Date Paiement/Client',
        'Date Paiement/Expert':'Date Paiement/Expert',
        'Grouper et générer les factures':'Grouper et générer les factures',
        'Réf.Facture ou Avoir/Client': 'Réf.Facture ou Avoir/Client',
        'Réf.Facture ou Avoir/Expert': 'Réf.Facture ou Avoir/Expert',
        'Total astreintes': 'Total astreintes',
        'N° du doc':'N° du doc',
        'Document à valider':'Document à valider',
        'Date effective (Souhaitée)':'Date effective (Souhaitée)',
        'Date effective':'Date effective',
        'Statut demande':'Statut demande',
        'Interruptions de missions':'Interruptions de missions',
        'Candidatures à traiter': 'Candidatures à traiter',
        'Candidat à interviewer': 'Candidat à interviewer',
        'Factures non payées': 'Factures non payées',
        'Analyse budgétaire': 'Analyse budgétaire',
        'Heures ouvrées': 'Heures ouvrées',
        'Type d\'HNO': 'Type d\'HNO',
        'Nom de société':'Nom de société',
        'Télécharger le document':'Télécharger le document',
        'Réf mission':'Réf mission',
        'Type du document*':'Type du document*',
        'Collaborateurs':'Collaborateurs',
        'Créer un appel d\'offres':'Créer un appel d\'offres',
        'Clôturer la publication':'Clôturer la publication',
        'Appels d\'offres en Brouillon':'Appels d\'offres en Brouillon',
        'Vous pouvez reprendre directement depuis le dernier AO non complété intitulé :':'Vous pouvez reprendre directement depuis le dernier AO non complété intitulé :',
        'progrès':'progrès',
        'Date début(Mission)':'Date début(Mission)',
        'Date création':'Date création',
        'Date fin estimée (Mission)':'Date fin estimée (Mission)',
        'Données Entreprise':'Données Entreprise',
        'Recherche Rapide':'Recherche Rapide',
        'Mots clés, exemple: (Angular ou “Node JS”) et React':'Mots clés, exemple: (Angular ou “Node JS”) et React',
        'Recherche Avancée':'Recherche Avancée',
        'Ajouter à un dossier':'Ajouter à un dossier',
        'Lier à un appel d\'offres':'Lier à un appel d\'offres',
        'Categories':'Categories',
        'Opérateurs et syntaxes:':'Opérateurs et syntaxes:',
        'A ET B: La recherche des CV qui doivent inclure A et B':'A ET B: La recherche des CV qui doivent inclure A et B',
        'A OU B: La recherche des CV qui incluent A et B ou les 2':'A OU B: La recherche des CV qui incluent A et B ou les 2',
        '“A B”: La recherche d\'un mot clé composé de deux mots (ex. “Spring Boot”)':'“A B”: La recherche d\'un mot clé composé de deux mots (ex. “Spring Boot”)',
        '(A OU B) et (C OU D): Les () pour affiner la recherche':'(A OU B) et (C OU D): Les () pour affiner la recherche',
        'A savoir:':'A savoir:',
        'Les recherches sont insensibles à la casse (Maj/min)':'Les recherches sont insensibles à la casse (Maj/min)',
        'Favoris':'Favoris',
        'Statut CV':'Statut CV',
        'Min d\'années d\'experiences':'Min d\'années d\'experiences',
        'Il est très recommandé de remplir tous les champs pour augmenter votre visibilité':'Il est très recommandé de remplir tous les champs pour augmenter votre visibilité',
        'Nom du certificat':'Nom du certificat',
        'Réf.Dossier':'Réf.Dossier',
        'Nom du dossier':'Nom du dossier',
        'Nb.de CV':'Nb.de CV',
        'Date création dossier':'Date création dossier',
        'Evaluer CV':'Evaluer CV',
        'Statut de la candidature':'Statut de la candidature',
        'Sauvegarder les données':'Sauvegarder les données',
        'Entrer ici un commentaire':'Entrer ici un commentaire',
        'Réf.PC':'Réf.PC',
        'Nom d\'expert':'Nom d\'expert',
        'Date de début':'Date de début',
        'Date de fin':'Date de fin',
        'Nb.jours BDC':'Nb.jours BDC',
        'Réf. BDC':'Réf. BDC',
        'Date Fin BDC':'Date Fin BDC',
        'Taux journalier TTC':'Taux journalier TTC',
        'Fréq. de renouvellement':'Fréq. de renouvellement',
        'Réf Expert':'Réf Expert',
        'Nb.j. restants':'Nb.j. restants',
        'Réf. Facture':'Réf. Facture',
        'Statut paiement':'Statut paiement',
        'Total applications':'Total applications',
        'Candidatures Lues':'Candidatures Lues',
        'Demandes d\'entretien':'Demandes d\'entretien',
        'Candidatures retenues':'Candidatures retenues',
        'Analyse chiffre d\'affaires':'Analyse chiffre d\'affaires',
        'Profil Personnel':'Profil Personnel',
        'Diplôme *':'Diplôme *',
        'Durée':'Durée',
        'De':'De',
        'Au*':'Au*',
        'De*':'De*',
        'Nom d\'entreprise *':'Nom d\'entreprise *',
        'Date fin':'Date fin',
        'Formation ou certificat':'Formation ou certificat',
        'Aucune donnée ajoutée':'Aucune donnée ajoutée',
        'Nom du diplôme *':'Nom du diplôme *',
        'Confidentiel ':'Confidentiel ',
        'TJM (€)':'TJM (€)',
        'Durée minimum de la mission':'Durée minimum de la mission',
        'Ajouter une entreprise':'Ajouter une entreprise',
        'Paramètres du compte':'Paramètres du compte',
        'Déconnexion du compte':'Déconnexion du compte',
        'Aucun appel d\'offres à afficher':'Aucun appel d\'offres à afficher',
        'Appels d\'offres favoris':'Appels d\'offres favoris',
        'Ordres de missions':'Ordres de missions',
        'Ajouter une note':'Ajouter une note',
        'Siret':'Siret',
        'Le CRA a été validé avec succès!':'Le CRA a été validé avec succès!',
        'Saisir la date du paiement':'Saisir la date du paiement',
        'La date de fin doit être postérieure à la date de début.':'La date de fin doit être postérieure à la date de début.',
        'Êtes-vous sûr de vouloir générer cette facture ?':'Êtes-vous sûr de vouloir générer cette facture ?',
    },
    en: {
        //Activation compte client
        'Vous allez recevoir un e-mail qui va vous informer de l\'activation de votre compte par notre équipe dans les prochaines heures.':'You will receive an email informing you of the activation of your account by our team in the next few hours.',
        'Votre demande pour rejoindre':'Your request to join',
        'est en cours de traitement et en attente d\'acceptation. Vous recevrez une notification par e-mail dès qu\'elle sera validée.':'is being processed and awaiting approval. You will receive an email notification once it is approved.',
        'Invitation est en attente!':'Invitation is pending!',
        'L\'activation du compte est en cours...':'Account activation is in progress...',
        'Finalisez votre profil!':'Complete your profile!',
        'Finalisez votre profil en cliquant ici':'Click here to complete your profile',

        'Statistiques':'Statistics',
        'Trafic des utilisateurs':'User traffic',
        'Trafic par géolocalisation':'Traffic by geolocation',
        'Nouveaux inscrits à la plateforme':'New subscribers',
        'Flux':'Flow',
        'AO et candidatures':'Jobs and applications',
        'Solde':'Balance',
        'Gestion des experts':'Expert Management',
        'Gestion des Experts':'Expert Management',
        'Fiches des experts':'Expert Sheet',
        'Demandeur':'Applicant',
        'Type Demandeur':'Applicant type',
        'Demande d\'interruption de mission':'Request for Assignment Interruption',
        'Date Effective de l\'interruption':'Date effective of the termination',
        'Date Effective(souhaitée)':'Date Effective(souhaitée)',
        'Date de demande':'Date of request',
        'Motif de l\'interruption':'Termination reason',
        'Traitées':'Processed',
        'Valider la demande d\'interruption de mission':'Approve the Request for Assignment Interruption',
        'Date effective de l\'interruption':'Termination effective date',
        'Motif à diffuser':'Reason given',
        'Rejeter la demande d\'interruption de mission':'Reject the Request for Assignment Interruption',
        'Demandes de suppression':'Deletion requests',
        'Demandes de suppression à valider':'Removal requests to validate',
        'Date de suppression':'Deletion date',
        'Statut de la demande':'Request status',
        'Motif de la suppression':'Deletion reason',
        //modifications
        'Mon Compte':'My Account',
        'Collaborateurs HTH':'HTH collaborators',
        'La facture est générée par le système une fois le compte rendu d\'activité(CRA) est validé par le consultant et le client.':'The invoice is generated by the system once the Timesheet (TS)/propal is validated by both the consultant and the client.',
        'Simulateur':'Simulator',
        'Gestion des Clients':'Client Management',
        'Gestion des missions':'Assignment Management',
        'Interruptions de mission':'Assignment Interruptions',
        'Facturation':'Billing',
        'Besoins ouverts':'Open Requests for Proposals', //a discuter avec #FZ
        'Candidats retenus':'Selected Candidates',
        'Missions en cours':'Ongoing Assignments',
        'Missions clôturées':'Closed Assignments',
        'CRA à valider':'Timesheet to validate',
        'Factures clients non payées':'Unpaid Client Invoices',
        'Factures experts non payées':'Unpaid Expert Invoices',
        'Chiffre d\'affaires':'Revenue',
        'Total AO': 'Total Purchase Orders',
        'Analyse des missions': 'Assignment Analysis',
        'Statuts CRA': 'Timesheet Status',
        'Rendez vous à venir': 'Upcoming Appointments',
        'Nom*' :'Last name*',
        'Prénom*' :'First name*',
        'Nouveaux inscrits à la platforme':'New registrations on the platform',
        'Evolution chiffre d\'affaire':'Revenue evolution',
        'Evolution de la marge brute et nette':'Evolution of gross and net margin',
        'Chiffre d\'affaire généré par CR':'Revenue generated by CR',
        'Chiffre d\'affaires et marges':'Revenue and margins',
        'Statut factures':'Invoice status',
        'Echéancier':'Schedule',
        'Collaborateurs High Tech Hires':'High Tech Hires Collaborators',
        'Compte entreprise':'Business Account',
        'Ajouter un expert':'Add an Expert',
        'Sous-catégorie':'Subcategory',
        'Statut Doc.administratifs':'Administrative Doc. Status',
        'Inviter un expert (externe)':'Invite an Expert (External)',
        'Envoyer une invitation':'Send an Invitation',
        'Toutes les catégories':'All categories',
        'Toutes les sous catégories':'All subcategories',
        'Catégories':'Categories',
        'Description (facultatif)':'Description (optional)',
        'Intitulé du poste*':'Job title',
        'Mon CV':'My Resume',
        'Technique ?':'Technical ?',
        'Valorisez votre profil auprès des clients et augmentez la visibilité de votre CV!':'Enhance your profile to clients and increase the visibility of your resume.',
        'Niveau':'Level',
        'Fonctionnelles ?':'Functional ?',
        'Ajouter une qualification':'Add a Qualification',
        'Langue':'Language',
        'Titre du poste recherché':'Job Title Sought',
        'Ajouter (3 nombre maximum d\'entrées)':'Add (maximum of 3 entries)',
        'Disponibilité *':'Availability *',
        'Fréquenece (télétravail)':'Frequency (telecommuting)',
        'Lieu de résidence *':'Residence Location *',
        'Immediate':'Immediate',
        'Secteur d\'activité (facultatif)':'Industry Sector (optional)',
        'Numéro TVA':'VAT Number',
        'Choisir votre pays':'Select your country',
        'Personnaliser plage de dates':'Customize date range',
        'Cette semaine':'This week',
        'Deux semaines':'Two weeks',
        'Ce mois-ci':'This month',
        'Type du document':'Document Type',
        'Télécharger l\'attestation URSSAF':'Download the URSSAF certificate',
        'Télécharger l\'attestation d\'assurance':'Download the insurance certificate',
        'Fiches des clients':'Client Sheet',
        'Nom client':'Client Name',
        'Type Facture':'Invoice Type',
        'Nombre de missions':'Assignments number',
        'Pays et ville':'Country and city',
        'Chargé de recrutement affecté':'Assigned recruitment officer',
        'Statut doc administratifs':'Administrative documents status',
        'Nom d\'entrerprise * :':'Company name * :',
        'Adresse *':'Address *',
        'Code Postal' :'Postcode',
        'Code Postal *':'Postcode *',
        'Numéro du TVA *':'VAT Number *',
        'Siret *':'Company registration number',
        'Informations de facturation':'Billing information', //a discuter avec #FZ
        'Adresse du siège':'Headquarters Address',
        'Collaborateurs d\'entreprise':'Company collaborators',
        'Autre adresse':'alternative address',
        'Numéro du TVA':'VAT Number',
        'Délai de paiement est à la date de facture':'Payment terms are due upon receipt of invoice',
        'Coefficient/Montant':'Coefficient/Amount',
        'heures ouvrées':'business hours',
        'Aucune donnée HNO n\'est définie':'No NWH data is defined',
        'Ajouter un HNO':'Add a NWH',
        'Ajouter une Astreinte':'Add an on-call',
        'Documents commericiaux':'commercial documents',
        'Liste des Collaborateurs':'Collaborators List',
        'Nb. de candidatures':'applications Number',
        'Candidatures "à interviewer"' : 'Applications "to interview"',
        'Candidatures "Retenues"' : 'Selected applications',
        'Date début Mission' : 'Assignment start date',
        'Date fin Mission' : 'Assignment End date',
        'Durée Mission' : 'Assignment duration',
        'Budget Max/j' : 'Maximum budget per day',
        'AO Créé par' : 'Job created by',
        'Cvtheque': 'CVLibrary',
        'Tout': 'All',
        'AO': 'Job',
        'Resp. opérationnel' : 'Operational Manager',
        'Resp. achat' : 'Procurement Manager',
        'Nb. de recrutement':'recruitments Number',

        'Code int. Client':'Int. Client Code',
        'Statut Candidatures':'Applications Status',
        'Ville/Pays':'City/Country',
        'Début de publication':'Publication start date',
        'Fin de publication':'Publication end date',
        'Modifier':'Edit',
        'Min.années d\'exp.':'Experience Min. years',
        'Techniques' : 'Technical',
        'Fonctionnelles':'Functional',
        'Aucune donnée':'No data',
        'Langues':'Languages',
        'Données entreprises':'Company data',
        'Masquer le nom de l\'entrerprise.':'Hide the company name',
        'Cadres administratifs du projet':'Project administrative framework',
        'L\'équipe est requise pour créer une mission. L\'admin pourra affecter plus qu\'un rôle au même collaborateur.':'The team is required to create an assignment. The admin will be able to assign more than one role to the same collaborator.',
        'Retour aux AO':'Return to jobs',
        'Modifier l\'appel d\'offres' : 'Modify job', //a discuter avec #FZ
        'Données Projet' : 'Project Data',
        'Exigences Projet' : 'Project Requirements',
        'Catégories & Sous catégorie' : 'Categories & Subcategories',
        'Durée de mission' : 'Assignment Duration',
        'Budget de la mission' : 'Assignment Budget',
        'Budget maximum/jour' : 'Maximum daily budget',
        'Visibilité Budget dans l\'AO' : 'Budget visibility in job',
        'Description du poste' : 'Job Description',
        'Aucun commentaire sur ce CV':'No comments on this CV',
        'Renvoyer une invitation': 'Resend an invitation',
        'Invitation acceptée': 'Invitation accepted',
        'Présentation et motivation':'Presentation and motivation',
        'Télécharger':'Download',
        'les scores de matching':'Matching scores',
        'Dossiers clients':'Client folders',
        'Clôturer le dossier':'Close folder',
        'Créer mission':'Create Assignment',
        'Voulez-vous empêcher la réinitialisation de la mission ?':'Do you want to prevent the assignment from resetting ?',
        'Créée le':'Created on',
        'Réf. Besoin':'Need ref.',
        'Nom Expert' :'Expert Name',
        'Nom Client' :'Client Name',
        'Réf.BDC/Client': 'PO/Client Ref.',
        'Réf.BDC/Expert': 'PO/Expert Ref.',
        'Réf. ordre de mission': 'Task Order Ref.',
        'Réf. proposition commerciale': 'Commercial proposition Ref.',
        'Proposition commerciale':'Commercial proposition',
        'Réf.Commande Client': 'Client Order Reference',
        'Tj/Expert (TTC)': 'Expert Price (VAT included)',
        'Commision appliquée': 'Applied Commission',
        'Tj/Client (TTC)': 'Client Price (VAT included)',
        'Marge nette': 'Net Margin',
        'Marge brute': 'Gross Margin',
        'Motif d\'interruption ou d\'annulation': 'Reason for Interruption or Cancellation',
        'Statut BDC':'Po Status',
        'Tj/Expert (HT)': 'Expert Price (excluding taxes)',
        'TVA Expert': 'Expert VAT (Value Added Tax)',
        'Tj/Client (HT)': 'Client Price (excluding taxes)',
        'Renouvellement':'Renewal',
        'Expert sécurité':'Security Expert',
        'Consultant SAP SD/MM':'SAP SD/MM Consultant',
        'Entreprises':'Companies',
        'Réf. AO ou CVThèque': 'Job or CVlibrary Ref.',
        'Nombre de poste': 'Number of Positions',
        'CVThèque':'CVlibrary',
        'Réf. expert': 'Expert ref.',
        'Renouveler Mission':'Renew Assignment',
        'Créer':'Create',
        'Télécharger le BDC':'Download the PO',
        'Signée le: ': 'Signed on: ',
        'Rejetée le: ': 'Rejected on: ',
        'Ordre de mission N°': 'Task Order No.',
        'pas de description':'no description',
        'Signée Par: ':'Signed By: ',
        'Rejetée Par: ':'Rejected By: ',
        'Réf:':'Ref:',
        'Réf':'Ref',
        'CRA':'Timesheet',
        'Réf.CRA':'Timesheet Ref.',
        'Réf.Expert':'Expert Ref.',
        'Date de validation/Expert':'Validation Date/Expert',
        'Date de validation/Client':'Validation Date/Client',
        'TJ HT/Expert':'Excl.VAT Rate/Expert',
        'TJ HT/Client':'Excl.VAT Rate/Client',
        'Compte rendu  d\'activité':'Timesheet',
        'de ':'of ',

        'CRA & Factures':'Timesheet & Invoices',
        'Réf.Int.Client': 'Internal Reference/Client',
        'Total HNO Client': 'Total NWH Client',
        'Total astreintes Client': 'Total on-call Client',
        'Total HNO Expert': 'Total NWH Expert',
        'Total astreintes Expert': 'Total on-call Expert',
        'Date de validation CRA': 'Timesheet Validation Date',
        'Délai Paiement': 'Payment Deadline',
        'Statut Paiement/Client': 'Payment Status/Client',
        'Statut Paiement/Expert': 'Payment Status/Expert',
        'TJ Expert': 'Expert Rate',
        'Date Paiement/Expert': 'Payment Date/Expert',
        'Date Paiement/Client': 'Payment Date/Client',
        'Grouper et générer les factures':'Group and generate invoices',
        'Réf.Facture ou Avoir/Client': 'Invoice or Credit Ref./Client',
        'Réf.Facture ou Avoir/Expert': 'Invoice or Credit Ref./Expert',
        'Total astreintes': 'Total On Calls',
        'N° du doc':'Document No.',
        'Document à valider':'Document to validate',
        'Date effective (Souhaitée)':'Effective Date (Desired)',
        'Date effective':'Effective Date',
        'Statut demande':'Request Status',
        'Interruptions de missions':'Assignment Interruptions',
        'Demandes d\'interruptions':'Interruption Requests',
        'Candidatures à traiter': 'Applications to process',
        'Candidat à interviewer': 'Candidate to interview',
        'Factures non payées': 'Unpaid invoices',
        'Analyse budgétaire': 'Budget analysis',
        'Heures ouvrées': 'Working hours',
        'Type d\'HNO': 'Type of NWH',
        'Nom de société':'Company Name',
        'Télécharger le document':'Download the document',
        'Réf.mission(si lié à une mission)':'Assignment ref. (if linked to a assignment)',
        'Réf mission':'Assignment ref.',
        'Type du document*':'Document Type*',
        'Collaborateurs':'Collaborators',
        'Créer un appel d\'offres':'Create a job posting',
        'Clôturer la publication':'Close the publication',
        'Appels d\'offres en Brouillon':'Jobs in Draft',
        'Vous pouvez reprendre directement depuis le dernier AO non complété intitulé :':'You can resume directly from the last incomplete job titled :',
        'progrès':'progress',
        'Date début(Mission)':'Start Date (Assignment)',
        'Date création':'Creation date',
        'Date fin estimée (Mission)':'Estimated End Date (Assignment)',
        'Données Entreprise':'Company Data',

        'Recherche Rapide':'Quick Search',
        'Mots clés, exemple: (Angular ou “Node JS”) et React':'Keywords, example: (Angular or "Node JS") and React',
        'Recherche Avancée':'Advanced Search',
        'Ajouter à un dossier':'Add to a folder',
        'Lier à un appel d\'offres':'Link to a job',
        'Categories':'Categories',
        'Opérateurs et syntaxes:':'Operators and Syntaxes:',
        'A ET B: La recherche des CV qui doivent inclure A et B':'A AND B: Search for resumes that must include both A and B',
        'A OU B: La recherche des CV qui incluent A et B ou les 2':'A OR B: Search for resumes that include A, B, or both',
        '“A B”: La recherche d\'un mot clé composé de deux mots (ex. “Spring Boot”)':'"A B": Search for a keyword composed of two words (e.g., "Spring Boot")',
        '(A OU B) et (C OU D): Les () pour affiner la recherche':'(A OR B) AND (C OR D): Use () to refine the search',
        'A savoir:':'Note:',
        'Les recherches sont insensibles à la casse (Maj/min)':'Searches are case insensitive (uppercase/lowercase)',
        'Favoris':'Favorites',
        'Statut CV':'CV Status',
        'Min d\'années d\'experiences':'Minimum years of experience',
        'Il est très recommandé de remplir tous les champs pour augmenter votre visibilité':'It is highly recommended to fill out all fields to increase your visibility',
        'Nom du certificat':'Certificate Name',
        'Réf.Dossier':'Folder Ref.',
        'Nom du dossier':'Folder Name',
        'Nb.de CV':'No. of Resumes',
        'Date création dossier':'Folder Creation Date',
        'Evaluer CV':'Evaluate Resume',
        'Statut de la candidature':'Application Status',
        'Sauvegarder les données':'Save Data',
        'Entrer ici un commentaire':'Enter a comment here',
        'Réf.PC':'PC Ref.',
        'Nom d\'expert':'Expert Name',
        'Date de début':'Start Date',
        'Date de fin':'End Date',
        'Nb.jours BDC':'No. of PO Days',
        'Réf. BDC':'PO ref.',
        'Date Fin BDC':'PO End Date',
        'Taux journalier TTC':'Daily Rate (incl. VAT)',
        'Fréq. de renouvellement':'Renewal Frequency',
        'Réf Expert':'Expert Ref.',
        'Nb.j. restants':'Remaining days',
        'Réf. Facture':'Invoice ref.',
        'Statut paiement':'Payment Status',
        'TVA appliquée':'Applied VAT',
        'Total applications':'Total Applications',
        'Candidatures Lues':'Applications Read',
        'Demandes d\'entretien':'Interview Requests',
        'Candidatures retenues':'Applications Shortlisted',
        'Analyse chiffre d\'affaires':'Revenue Analysis',
        'Profil Personnel':'Personal Profile',
        'Détails du diplôme':'Diploma Details',
        'Diplôme *':'Diploma*',
        'Avez-vous des modifications à faire sur le CRA de la prestation complémentaire?':'Do you have any changes to make to the Timesheet (TS)/propal of the additional service?',
        'Avez vous des astreintes, des HNO ou notes de frais à ajouter?':'Do you have any on-call, NWH, or expense reports to add?',
        'Université/Ecole':'University/School',
        'Durée':'Duration',
        'De':'From',
        'De*':'From*',
        'Au*':'To*',
        'Nom d\'entreprise *':'Company Name*',
        'Secteur d\'activité de l\'entreprise (facultatif)':'Company Industry (optional)',
        'Date fin':'End Date',
        'Formation ou certificat':'Training or Certificate',
        'Aucune donnée ajoutée':'No data added',
        'Nom du diplôme *':'Diploma Name *',
        'Confidentiel ':'Confidential ',
        'TJM (€)':'MDR (€)',
        'Durée minimum de la mission':'Minimum Duration of the assignment',
        'Ajouter une entreprise':'Add a Company',
        'Paramètres du compte':'Account Settings',
        'Déconnexion du compte':'Logout',
        'Aucun appel d\'offres à afficher':'No jobs to display',
        'Appels d\'offres favoris':'Favorite jobs',
        'Ordres de missions':'Work Orders',
        'Nb de jours BDC':'No. of PO days',
        'Ajouter une note':'Add a note',
        'Siret':'Company registration number',
        'Votre profil a été complété avec succès!':'Your profile has been successfully completed!',
        'Félicitation!':'Congratulations!',
        'page d\'accueil':'Homepage',
        'Le CRA a été validé avec succès!' : 'The CRA has been successfully validated!',
        'Saisir la date du paiement' : 'Enter the payment date',
        'La date de fin doit être postérieure à la date de début.' : 'The end date must be after the start date.',
        'Êtes-vous sûr de vouloir générer cette facture ?' : 'Are you sure you want to generate this invoice?',

    }
};